<template>
  <div class="formField">
    <div class="phoneNumberField" :class="{'isError': fieldErrors?.length}">
      <button class="phoneNumberField__Label" @click="focusInput">{{ label }}<span class="form__LabelRequired" v-if="required">*</span></button>
      <div class="phoneNumberField__FieldsWrapper">
        <div class="phoneNumberField__CountryCode">
          <SelectField autocomplete v-model="dialCode" :options="countriesDialCodes" value-key="dialCode" text-key="dialCode">
            <template #option="{ item }">
              <span>{{ item.dialCode }}</span>
            </template>
          </SelectField>
        </div>
        <div class="phoneNumberField__Input">
          <TextField v-model="number" :label="label" type="number" ref="textField" :validate="{type: ['required', 'minlength', 'maxlength'], minlength: 5, maxlength: 20, message: {required: $t('formErrors.required'), minlength: $t('formErrors.minLength', 5), maxlength: $t('formErrors.maxLength', 20)}}" v-if="required"/>
          <TextField v-model="number" :label="label" type="number" ref="textField" v-else/>
        </div>
      </div>
    </div>
    <FormError :errors="fieldErrors" className="textField__Error" />
    <span class="textField__Info form__Info" v-html="info" v-if="info" />
  </div>
</template>

<script setup>
  import countriesDialCodes from '~/data/countries';
  const emit = defineEmits(['update:numberValue', 'update:codeValue']);
  const props = defineProps({
    codeValue: {},
    numberValue: {},
    label: {
      type: String,
    },
    info: {},
    required: {
      type: Boolean,
      default: true,
    },
  })
  
  const dialCode = useComputedModel(props, emit, 'codeValue');
  const number = useComputedModel(props, emit, 'numberValue');
  const textField = ref(null);

  const fieldErrors = computed(() => textField.value?.mergedErrors);

  function focusInput() {
    if (textField.value.$el) textField.value.$el.querySelector('input').focus();
  }

  function triggerValidate() {
    return textField.value.triggerValidate();
  }

  watch(() => dialCode.value, () => {
    focusInput();
  })

  defineExpose({
    triggerValidate,
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/components/forms/_phoneNumberField.scss');
</style>
